import React from "react";
import { CheckCircle2, AlertTriangle, Info, X } from "lucide-react";

export type NoticeTone = "success" | "error" | "info";

export type NoticeItem = {
  id: number;
  message: string;
  tone: NoticeTone;
};

function toneStyles(tone: NoticeTone) {
  if (tone === "success") {
    return {
      wrap: "border-emerald-500/30 bg-emerald-500/10 text-emerald-100",
      icon: <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-300" />,
    };
  }

  if (tone === "error") {
    return {
      wrap: "border-red-500/30 bg-red-500/10 text-red-100",
      icon: <AlertTriangle className="h-4 w-4 shrink-0 text-red-300" />,
    };
  }

  return {
    wrap: "border-sky-500/30 bg-sky-500/10 text-sky-100",
    icon: <Info className="h-4 w-4 shrink-0 text-sky-300" />,
  };
}

export default function NoticeStack({
  notices,
  onDismiss,
}: {
  notices: NoticeItem[];
  onDismiss: (id: number) => void;
}) {
  if (!notices.length) return null;

  return (
    <div className="fixed right-4 top-20 z-50 flex w-[min(420px,calc(100vw-2rem))] flex-col gap-3">
      {notices.map((notice) => {
        const styles = toneStyles(notice.tone);

        return (
          <div
            key={notice.id}
            className={`flex items-start gap-3 rounded-2xl border px-4 py-3 shadow-[0_16px_40px_rgba(0,0,0,0.45)] backdrop-blur ${styles.wrap}`}
          >
            {styles.icon}
            <div className="min-w-0 flex-1 text-sm font-medium leading-6">
              {notice.message}
            </div>
            <button
              type="button"
              onClick={() => onDismiss(notice.id)}
              className="rounded-full border border-white/10 bg-white/5 p-1 text-white/70 transition hover:bg-white/10 hover:text-white"
              aria-label="Dismiss notification"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
